const colors = {
  petrol: { 300: '#3F7680', 400: '#235963', 500: '#0B4752', 600: '#113D45' },
  peach: { 200: '#FFDED2', 400: '#F69774', 500: '#E47B53', 600: '#E55823', 800: '#C73000' },
  sand: { 100: '#F3F0EB', 400: '#EBE7E2', 500: '#F3F0EB', 600: '#DED8CE', 700: '#BAB1A1' },
  pink: { 500: '#E6CFE3', 600: '#C592BF' },
  blue: { 500: '#C5E7E8', 600: '#91C9CA', 700: '#5CB5B8' },
  yellow: { 400: '#FAFFB1', 500: '#EFF690', 600: '#F5FF67', 800: '#F1BF42' },
  white: { 500: '#FFFFFF' },
  // orange: null, // will be aliased to peach below
}

export default colors
